export const imageUploadConfig = {
    SIZE: 5000,
    IMAGE_UPLOAD_TIMER_MIN: process.env.REACT_APP_IMAGE_UPLOAD_TIMER_MIN ?? 0,
    IMAGE_UPLOAD_TIMER_SEC: process.env.REACT_APP_IMAGE_UPLOAD_TIMER_SEC ?? 0,
    // MIN_DIMENSION: 1000,
    // MAX_DIMENSION: 1200
};